import arrayMove from "array-move";
import { EducationHistory, Subjects as ResumeSubject } from "jobjump-types/Resume";
import { Subject } from "jobjump-types/Subjects";
import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import Button from "../../../components/Button";
import { Label, TextField } from "../../../components/Form";
import CreatableSelect from "../../../components/Form/CreatableSelect";
import { Col, Row } from "../../../components/grid";
import Subjects from "../../../data/Subjects";
import { SubsectionProps, SubsectionTemplate, deleteFromList, updateObjectIndex, SortableItemTemplate } from "./common";

type SortableListItems = ResumeSubject & {
    originalOrder: number
};

const SortableItem = SortableElement(
    ({ data, onChange, onDelete, subject }: {data:SortableListItems, onChange:(t:ResumeSubject)=>void, onDelete:()=>void, subject:ResumeSubject[]}) => {
        return <SortableItemTemplate onDelete={onDelete}>
            <Row className="mt-8">
                <Col sm={4}>
                    <CreatableSelect value={{label:data.name, value:data.name}} 
                        options={subject.map(s => ({label:s.name, value:s.name}))}
                        onChange={v => v && onChange({...data, name:v.value})} />
                </Col>
                <Col sm={4}>
                    <TextField value={data.mark} onChange={v=>onChange({...data, mark:v})} />
                </Col>
                <Col sm={4}>
                    <TextField value={data.comment} onChange={v=>onChange({...data, comment:v})} />
                </Col>
            </Row>
        </SortableItemTemplate>
    }
)

const SortableList = SortableContainer(
    (props:{data:SortableListItems[], section:EducationHistory, setSection:(r:EducationHistory)=>void, subjects:Subject[]}) => <div>
        {props.data.map((t: SortableListItems, i: number) => {
            return <div id={`sortable-resume-item-${t.originalOrder}`} key={"key-" + t.originalOrder}>
                <SortableItem 
                    subject={props.subjects}
                    index={i} 
                    data={t} 
                    onChange={(t)=>props.setSection({...props.section, subjects:updateObjectIndex(props.section.subjects, t, i)})} 
                    onDelete={()=>props.setSection({...props.section, subjects:deleteFromList(props.section.subjects, i)})} />
            </div>
        })}
    </div>
);

const EducationHistorySection : React.FC<SubsectionProps<"education_history">> = ({section, setSection, sectionConfig, setSectionConfig}) => {
    const [subject, setSubjects] = React.useState<Subject[]>([]);
    React.useEffect(() => {
        Subjects.getSubjects().then(setSubjects);
    }, []);
    return <SubsectionTemplate
        title="Education History"
        sectionSetting={sectionConfig}
        updateSectionSetting={setSectionConfig}
        buttons={[
            {text:"Subject", onClick:()=>setSection({...section, subjects: section.subjects.concat([{name:"", mark:"", comment:""}])})},
        ]}>
            <Row className="mb-16">
                <Col>
                    <Label>School Name</Label>
                    <TextField value={section.schoolName} onChange={(v)=>setSection({...section, schoolName: v})} />
                </Col>
            </Row>
            <Row className="mb-8">
                <Col>
                    <h4>Subjects</h4>
                </Col>
            </Row>
            <Row style={{paddingLeft:"56px", paddingRight:"56px"}}>
                <Col sm={4}>
                    <Label>Subject</Label>
                </Col>
                <Col sm={4}>
                    <Label>Mark</Label>
                </Col>
                <Col sm={4}>
                    <Label>Additional Comments</Label>
                </Col>
            </Row>
            <SortableList
                axis="xy"
                distance={0}
                data={section.subjects.map((s,i) => ({...s, originalOrder:i}))}
                useDragHandle
                onSortEnd={({oldIndex, newIndex}) => {
                    const order = arrayMove(section.subjects, oldIndex, newIndex);
                    setSection({...section, subjects:order});
                }} 
                subjects={subject}
                section={section}
                setSection={setSection} />
            {section.subjects.length === 0 && <Row className="mb-64 mt-64">
                <Col className="text-center">
                    <Button variant="active" onClick={()=>setSection({...section, subjects:section.subjects.concat([{name:"", mark:"", comment:""}])})}>
                        Add Subject
                    </Button>
                </Col>
            </Row>} 
        </SubsectionTemplate>
}

export default EducationHistorySection